var _g, _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _ellipse7, _ellipse8, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIconPlanetWithFlagAndRings = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    className,
    height = 61,
    titleId,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 160 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: className,
    height: height,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M18.3691 23C21.5353 23 22.9156 21.6815 22.9156 18.5C22.9156 21.6815 24.2864 23 27.4622 23C24.2864 23 22.9156 24.3567 22.9156 27.5C22.9156 24.3567 21.5353 23 18.3691 23Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 2.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.496 51C131.662 51 133.043 49.6815 133.043 46.5C133.043 49.6815 134.413 51 137.589 51C134.413 51 133.043 52.3567 133.043 55.5C133.043 52.3567 131.662 51 128.496 51Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 2.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 135.539,
    cy: 2.08552,
    rx: 1.60191,
    ry: 1.58552,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 111.912,
    cy: 20.0855,
    rx: 1.60191,
    ry: 1.58552,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 41.1878,
    cy: 5.08552,
    rx: 1.60191,
    ry: 1.58552,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 159.053,
    cy: 25.0725,
    rx: 0.947469,
    ry: 0.937778,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 131.188,
    cy: 28.2347,
    rx: 0.947469,
    ry: 0.937778,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.947469,
    cy: 12.678,
    rx: 0.947469,
    ry: 0.937778,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 21.9025,
    cy: 48.6087,
    rx: 0.947469,
    ry: 0.937778,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 2.26011,
    cy: 59.1656,
    rx: 1.60191,
    ry: 1.58552,
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M98.1079 56.9539C97.3695 54.1983 99.3485 51.2738 102.528 50.4218C104.196 49.9748 105.863 50.1871 107.178 50.8878",
    stroke: "currentColor",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.7678 30.6422C69.8577 33.6027 69.9626 38.5076 67.0021 41.5975C64.0416 44.6874 59.1368 44.7923 56.0469 41.8318",
    stroke: "currentColor",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.079 54.1555C107.079 39.3207 95.0531 27.2947 80.2182 27.2947C65.3834 27.2947 53.3574 39.3207 53.3574 54.1555",
    stroke: "currentColor",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.1641 15.9566L83.3299 5.17448C83.3643 4.85574 83.6362 4.61588 83.9567 4.62134L85.7009 3.76354C87.1565 3.0477 88.8668 3.07234 90.3011 3.82979V3.82979C91.4326 4.42733 92.7484 4.57442 93.9839 4.2415L99.2746 2.81591C99.639 2.82212 99.9195 3.13992 99.8803 3.50231L98.7875 13.6096C98.753 13.9284 98.4812 14.1682 98.1607 14.1628L92.7985 15.5723C91.4969 15.9145 90.1151 15.767 88.9151 15.158V15.158C87.4292 14.4039 85.6813 14.3649 84.1633 15.0519L82.1641 15.9566ZM82.1641 15.9566L80.2182 33.1266",
    stroke: "currentColor",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 85.8993,
    cy: 44.3409,
    r: 1.54966,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.0467 58.3147C59.6909 58.3147 44 54.1533 44 49.0199C44 46.2677 48.5103 43.7949 55.6774 42.093",
    stroke: "currentColor",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.1516 57.7713C64.465 44.0847 55.0053 28.617 58.6351 24.9872C60.5812 23.0411 65.519 24.4818 71.7904 28.3463",
    stroke: "currentColor",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.271 42.0811C111.468 43.7833 116 46.2614 116 49.0202C116 54.1535 100.309 58.315 80.9536 58.315H78.668",
    stroke: "currentColor",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.7994 57.7706C84.1103 56.4597 86.7611 53.7159 87.965 52.408C99.3303 40.0607 105.682 28.2689 102.399 24.9867C100.449 23.0359 95.4919 24.4882 89.1991 28.3737",
    stroke: "currentColor",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })))));
});
export const Icon = /*#__PURE__*/React.forwardRef((_ref2, ref) => {
  let {
    className: propClassName = "",
    fill = "none",
    stroke = "currentColor",
    weight = "normal",
    height = 61,
    titleId,
    title,
    ...props
  } = _ref2;
  const className = "vector-effect-non-scaling-stroke " + propClassName;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 160 61",
    fill: fill,
    xmlns: "http://www.w3.org/2000/svg",
    className: className,
    height: height,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M18.3691 23C21.5353 23 22.9156 21.6815 22.9156 18.5C22.9156 21.6815 24.2864 23 27.4622 23C24.2864 23 22.9156 24.3567 22.9156 27.5C22.9156 24.3567 21.5353 23 18.3691 23Z",
    fill: "currentColor",
    stroke: stroke,
    strokeWidth: weight === "normal" ? 1.5 : 1,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.496 51C131.662 51 133.043 49.6815 133.043 46.5C133.043 49.6815 134.413 51 137.589 51C134.413 51 133.043 52.3567 133.043 55.5C133.043 52.3567 131.662 51 128.496 51Z",
    fill: "currentColor",
    stroke: stroke,
    strokeWidth: weight === "normal" ? 1.5 : 1,
    strokeLinejoin: "round"
  }), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 135.539,
    cy: 2.08552,
    rx: 1.60191,
    ry: 1.58552,
    fill: "currentColor"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 111.912,
    cy: 20.0855,
    rx: 1.60191,
    ry: 1.58552,
    fill: "currentColor"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 41.1878,
    cy: 5.08552,
    rx: 1.60191,
    ry: 1.58552,
    fill: "currentColor"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 159.053,
    cy: 25.0725,
    rx: 0.947469,
    ry: 0.937778,
    fill: "currentColor"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 131.188,
    cy: 28.2347,
    rx: 0.947469,
    ry: 0.937778,
    fill: "currentColor"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.947469,
    cy: 12.678,
    rx: 0.947469,
    ry: 0.937778,
    fill: "currentColor"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 21.9025,
    cy: 48.6087,
    rx: 0.947469,
    ry: 0.937778,
    fill: "currentColor"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 2.26011,
    cy: 59.1656,
    rx: 1.60191,
    ry: 1.58552,
    fill: "currentColor"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M98.1079 56.9539C97.3695 54.1983 99.3485 51.2738 102.528 50.4218C104.196 49.9748 105.863 50.1871 107.178 50.8878",
    stroke: stroke,
    strokeWidth: weight === "normal" ? 1.5 : 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.7678 30.6422C69.8577 33.6027 69.9626 38.5076 67.0021 41.5975C64.0416 44.6874 59.1368 44.7923 56.0469 41.8318",
    stroke: stroke,
    strokeWidth: weight === "normal" ? 1.5 : 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.079 54.1555C107.079 39.3207 95.0531 27.2947 80.2182 27.2947C65.3834 27.2947 53.3574 39.3207 53.3574 54.1555",
    stroke: stroke,
    strokeWidth: weight === "normal" ? 1.5 : 1,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.1641 15.9566L83.3299 5.17448C83.3643 4.85574 83.6362 4.61588 83.9567 4.62134L85.7009 3.76354C87.1565 3.0477 88.8668 3.07234 90.3011 3.82979V3.82979C91.4326 4.42733 92.7484 4.57442 93.9839 4.2415L99.2746 2.81591C99.639 2.82212 99.9195 3.13992 99.8803 3.50231L98.7875 13.6096C98.753 13.9284 98.4812 14.1682 98.1607 14.1628L92.7985 15.5723C91.4969 15.9145 90.1151 15.767 88.9151 15.158V15.158C87.4292 14.4039 85.6813 14.3649 84.1633 15.0519L82.1641 15.9566ZM82.1641 15.9566L80.2182 33.1266",
    stroke: stroke,
    strokeWidth: weight === "normal" ? 1.5 : 1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 85.8993,
    cy: 44.3409,
    r: 1.54966,
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M79.0467 58.3147C59.6909 58.3147 44 54.1533 44 49.0199C44 46.2677 48.5103 43.7949 55.6774 42.093",
    stroke: stroke,
    strokeWidth: weight === "normal" ? 1.5 : 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.1516 57.7713C64.465 44.0847 55.0053 28.617 58.6351 24.9872C60.5812 23.0411 65.519 24.4818 71.7904 28.3463",
    stroke: stroke,
    strokeWidth: weight === "normal" ? 1.5 : 1,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.271 42.0811C111.468 43.7833 116 46.2614 116 49.0202C116 54.1535 100.309 58.315 80.9536 58.315H78.668",
    stroke: stroke,
    strokeWidth: weight === "normal" ? 1.5 : 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.7994 57.7706C84.1103 56.4597 86.7611 53.7159 87.965 52.408C99.3303 40.0607 105.682 28.2689 102.399 24.9867C100.449 23.0359 95.4919 24.4882 89.1991 28.3737",
    stroke: stroke,
    strokeWidth: weight === "normal" ? 1.5 : 1,
    strokeLinecap: "round"
  }))));
});
export default SvgIconPlanetWithFlagAndRings;
export const raw = __webpack_public_path__ + "static/media/icon-planet-with-flag-and-rings.fc3b976e2817ec15c59c89fa4517c06c.svg";